import { render } from "./LoadingAnimation.vue?vue&type=template&id=5929fc9e&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=5929fc9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5929fc9e"]])

export default __exports__